import * as React from 'react';

import { EReadyBusinessType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './ReadyBusinessAssignment.css';
import { useOfferSelector } from '../../hooks/selectors/useOfferSelector';
import { isBusinessSale } from '../../utils/commercial';
import { getNewBusinessSaleSpecialtiesTitle } from '../../utils/getNewBusinessSaleSpecialtiesTitle';

export const ReadyBusinessAssignment: React.VFC = () => {
  const offer = useOfferSelector();

  const isOtherReadyBusinessType = offer.readyBusinessType === EReadyBusinessType.Other;

  const newBusinessSaleSpecialtiesTitle = getNewBusinessSaleSpecialtiesTitle(offer.specialty?.specialties);

  if (isBusinessSale(offer) && !isOtherReadyBusinessType && newBusinessSaleSpecialtiesTitle) {
    return (
      <div className={styles['container']}>
        <div className={styles['specialty']}>
          <div className={styles['specialties-title']}>Назначение</div>
          <div className={styles['specialties']}>
            <div data-testid="ready-business-assignment_specialties-text" className={styles['specialties-text']}>
              {newBusinessSaleSpecialtiesTitle}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

ReadyBusinessAssignment.displayName = 'ReadyBusinessAssignment';
